<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper without-bottom-cta">
    <div class="behaviour-card-sec">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{
            caseParams.case?.student?.firstName +
              ' ' +
              caseParams.case?.student?.lastName
          }}
        </h3>
      </div>
      <div class="card-content-wrapper">
        <div class="content">
          <h4 class="title">Date Of Birth</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-calendar.svg"
              class="icon s-16"></svg-icon>
            {{
              caseParams.case?.student?.dateOfBirth ?? null | date: 'MM/dd/yyyy'
            }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Supervisor</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-supervisor.svg"
              class="icon s-16"></svg-icon>
            {{ caseParams.case?.supervisorName }}
          </p>
        </div>
        <div class="content">
          <h4 class="title">Gender</h4>
          <p class="desc">
            <svg-icon
              src="/assets/icon/icon-male.svg"
              class="icon s-16"></svg-icon>
            {{ caseParams.case?.student?.gender }}
          </p>
        </div>
      </div>
    </div>
    <!-- <form nz-form [formGroup]="schoolForm" class="form" nzLayout="horizontal">
      <div class="form-grid">
        <nz-form-item>
          <nz-form-label nzFor="schools">Schools</nz-form-label>
          <nz-form-control nzErrorTip="Please input schools.">
            <nz-select
              formControlName="orgId"
              nzSuffixIcon
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select schools"
              [nzOptionOverflowSize]="7"
              (ngModelChange)="onSchoolChange($event)">
              <nz-option
                *ngFor="let item of (caseOrganizations$ | async) ?? []"
                [nzLabel]="item.organizationName"
                [nzValue]="item.id">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </form> -->
    <div class="header-with-cta without-border">
      <h3 class="title s-18">Add Team Members</h3>
      <div class="cta-wrapper">
        <app-organization-search
          [defaultSelectedOrg]="orgId"
          (orgChange)="orgChange($event)">
        </app-organization-search>
        <app-search-input
          placeholder="Search members"
          [debounceTime]="1000"
          (searchChange)="handleSearch($event)">
        </app-search-input>
      </div>
    </div>
    <nz-table
      [nzData]="(usersBySchool$ | async) ?? []"
      nzTableLayout="fixed"
      [nzScroll]="{ x: '900' }"
      [nzTotal]="totalRows"
      [nzFrontPagination]="false"
      [(nzPageIndex)]="pageIndex"
      [nzPageSize]="pageSize"
      (nzQueryParams)="onQueryParamsChange($event)">
      <thead>
        <tr>
          <th
            nzWidth="300px"
            [nzSortFn]="true"
            [nzColumnKey]="listOfColumn[0].key">
            {{ listOfColumn[0].title }}
          </th>
          <th nzAlign="center" nzWidth="150px">
            {{ listOfColumn[1].title }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of (usersBySchool$ | async) ?? []; let i = index">
          <td>
            {{ data.name }}
          </td>
          <td>
            <div class="action-btn-wrapper">
              <button
                nz-button
                nzType="text"
                class="primary-text-btn"
                (click)="onCreateMember(data)"
                [disabled]="existingMemberIds.has(data.id)">
                {{ existingMemberIds.has(data.id) ? 'Added' : 'Add to team' }}
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</nz-spin>
